import React, { useState } from 'react';
import styles from './Reactions.module.scss';
import cx from 'classnames';
import Emoji from '../../Emoji/Emoji';
import Avatar from '../../Avatar/Avatar';
import Icon from '../../Icon/Icon';
import { useTranslation } from 'react-i18next';

const ReactionsList = ({
  reactions,
  user,
  handleReaction,
  reactionStatistics,
  setShowReactionList,
}) => {
  const [selectedFilter, setSelectFilter] = useState('All');
  const { t } = useTranslation();

  const clickReaction = reaction => {
    if (reactionStatistics.filter(emoji => emoji.unicode === reaction.unicode)[0].amount <= 1) {
      setSelectFilter('All');
    }
    handleReaction(reaction);
  };

  const sortByUsername = array => {
    return array.sort((a, b) =>
      a.username !== user?.username && b.username === user?.username
        ? 1
        : a.username === user?.username && b.username !== user?.username
        ? -1
        : 0
    );
  };

  const filtered = sortByUsername(reactions.filter(reaction => reaction.unicode === selectedFilter || selectedFilter === 'All'));

  return (
    <div className={styles.reactionsListContainer}>
      <div className={styles.reactionsListHeader}>
        <ul className={styles.filterActionbar}>
          <li
            className={cx(styles.filterActionButton, { [styles.selectedFilter]: selectedFilter === 'All' })}
            onClick={() => setSelectFilter('All')}
          >
            <span className={styles.filterActionText}>{t('reactions.all')}</span>
          </li>
          {reactionStatistics.map(emoji => (
            <li
              key={emoji.unicode}
              className={cx(styles.reaction, { [styles.selectedFilter]: selectedFilter === emoji.unicode })}
              onClick={() => setSelectFilter(emoji.unicode)}
            >
              <Emoji unicode={emoji.unicode} />
              <span className={styles.reactionNumber}>{emoji.amount}</span>
            </li>
          ))}
        </ul>
        <div className={styles.closeBtn} onClick={() => setShowReactionList(false)}>
          <Icon className={styles.icon} src="close" />
        </div>
      </div>
      <ul className={styles.reactionsList}>
        {filtered.map(reaction => (
          <li key={`${reaction.authorName} ${reaction.unicode}`} className={cx(styles.reactionItem)}>
            <div className={cx(styles.reactionDetail)}>
              <Avatar
                className={styles.miniUserDetail}
                image={reaction?.avatar || undefined}
                title={reaction?.authorName}
                size="small"
              />
              <span className={styles.reactionName}>{reaction.authorName}</span>
              <Emoji unicode={reaction.unicode} />
            </div>
            {reaction?.username === user?.username ? (
              <div className={styles.trashIcon} onClick={() => clickReaction(reaction)}>
                <Icon src="trash" verticalAlign="middle" style={{ fontSize: '24px' }} />
              </div>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReactionsList;
